import _ from 'lodash';
import { allDishImages } from '../dish-images';
// 过敏原
export const ALLERGEN = [{
    key: 'gluten',
    text: 'food_configure_text_gluten',
    icon: allDishImages['ALLERGEN_GLUTEN']
}, {
    key: 'crustaceans',
    text: 'food_configure_text_crustaceans',
    icon: allDishImages['ALLERGEN_CRUSTACEANS']
}, {
    key: 'eggs',
    text: 'food_configure_text_eggs',
    icon: allDishImages['ALLERGEN_EGGS']
}, {
    key: 'fish',
    text: 'food_configure_text_fish',
    icon: allDishImages['ALLERGEN_FISH']
}, {
    key: 'peanuts',
    text: 'food_configure_text_peanuts',
    icon: allDishImages['ALLERGEN_PEANUTS']
}, {
    key: 'soya',
    text: 'food_configure_text_soya',
    icon: allDishImages['ALLERGEN_SOYA']
}, {
    key: 'milk',
    text: 'food_configure_text_milk',
    icon: allDishImages['ALLERGEN_MILK']
}, {
    key: 'tree_nuts',
    text: 'food_configure_text_tree_nuts',
    icon: allDishImages['ALLERGEN_TREE_NUTS']
}, {
    key: 'celery',
    text: 'food_configure_text_celery',
    icon: allDishImages['ALLERGEN_CELERY']
}, {
    key: 'mustard',
    text: 'food_configure_text_mustard',
    icon: allDishImages['ALLERGEN_MUSTARD']
}, {
    key: 'sesame',
    text: 'food_configure_text_sesame',
    icon: allDishImages['ALLERGEN_SESAME']
}, {
    key: 'sulphites',
    text: 'food_configure_text_sulphites',
    icon: allDishImages['ALLERGEN_SULPHITES']
}, {
    key: 'lupin',
    text: 'food_configure_text_lupin',
    icon: allDishImages['ALLERGEN_LUPIN']
}, {
    key: 'molluscs',
    text: 'food_configure_text_molluscs',
    icon: allDishImages['ALLERGEN_MOLLUSCE']
}]

//   配料(其他菜品标识)
export const INGREDIENTS = [
    {
        key: 'mild_spicy',
        text: 'food_configure_text_slightly_spicy',
        icon: allDishImages['INGREDIENTS_MILD_SPICY']
    },
    {
        key: 'medium_spicy',
        text: 'food_configure_text_medium_spicy',
        icon: allDishImages['INGREDIENTS_MEDIUM_SPICY']
    },
    {
        key: 'very_spicy',
        text: 'food_configure_text_heavy_spicy',
        icon: allDishImages['INGREDIENTS_VERY_SPICY']
    },
    {
        key: 'frozen_origin',
        text: 'food_configure_text_buy_source_quick_frozen',
        icon: allDishImages['INGREDIENTS_FROZEN_ORIGIN']
    },
    {
        key: 'blast_freezing',
        text: 'food_configure_text_preventative_quick_freezing',
        icon: allDishImages['INGREDIENTS_BLAST_FREEZING']
    },
    {
        key: 'vegetarian',
        text: 'food_configure_text_vegetarianism',
        icon: allDishImages['INGREDIENTS_VEGETARIAN']
    },
    {
        key: 'vegan',
        text: 'food_configure_text_wigan',
        icon: allDishImages['INGREDIENTS_VEGAN']
    },
    {
        key: 'gluten_free',
        text: 'food_configure_text_gluten_free_food',
        icon: allDishImages['INGREDIENTS_GLUTEN_FREE']
    },
    {
        key: 'raw',
        text: 'food_configure_text_raw_food',
        icon: allDishImages['INGREDIENTS_RAW']
    },
    {
        key: 'cooked',
        text: 'food_configure_text_delicatessen',
        icon: allDishImages['INGREDIENTS_COOKED']
    },
    {
        key: 'additives',
        text: 'food_configure_text_additives',
        icon: allDishImages['INGREDIENTS_ADDITIVES']
    },
    {
        key: 'colourants',
        text: 'food_configure_text_coloring',
        icon: allDishImages['INGREDIENTS_COLOURANTS']
    },
    {
        key: 'pig',
        text: 'food_configure_text_pork',
        icon: allDishImages['INGREDIENTS_PIG']
    }
];

/** 与 RBP2 `dish-base-data` 一致：菜品多语言 JSON（item_i18n）字段映射 */
export const getI18nMap = (key: string): string => {
    const i18nMap = new Map<string, string>([
        ['item_name1', 'name1'],
        ['item_name2', 'name2'],
        ['item_description', 'remark'],
        ['ext_dish_info', 'extra_remark'],
    ]);
    return i18nMap.get(key) || '';
};

export const defaultI18n = {
    EN: { name1: '', name2: '', remark: '', extra_remark: '' },
    ZH: { name1: '', name2: '', remark: '', extra_remark: '' },
    IT: { name1: '', name2: '', remark: '', extra_remark: '' },
    ES: { name1: '', name2: '', remark: '', extra_remark: '' },
    FR: { name1: '', name2: '', remark: '', extra_remark: '' },
    DE: { name1: '', name2: '', remark: '', extra_remark: '' },
    PT: { name1: '', name2: '', remark: '', extra_remark: '' },
    SL: { name1: '', name2: '', remark: '', extra_remark: '' },
    CA: { name1: '', name2: '', remark: '', extra_remark: '' },
    default: { name1: '', name2: '', remark: '', extra_remark: '' },
};

export type DishItemI18nShape = typeof defaultI18n;

/** 解析 item_i18n JSON，与 defaultI18n 合并以兼容旧数据 */
export const parseI18n = (str: string): DishItemI18nShape => {
    try {
        const parsed = str ? JSON.parse(str) : {};
        return _.merge({}, _.cloneDeep(defaultI18n), parsed);
    } catch {
        return _.cloneDeep(defaultI18n);
    }
};